import { render, staticRenderFns } from "./fix-side-intro.vue?vue&type=template&id=1bd7c37e&scoped=true"
import script from "./fix-side-intro.vue?vue&type=script&lang=js"
export * from "./fix-side-intro.vue?vue&type=script&lang=js"
import style0 from "./fix-side-intro.vue?vue&type=style&index=0&id=1bd7c37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd7c37e",
  null
  
)

export default component.exports